<template>
  <transition name="fade">
    <div v-if="visible" class="alert-grid lh-copy" :class="alertClass">
      <div class="ph3" id="alert">
        <slot />
      </div>
      <button @click="$emit('dismiss')" class="input-icon-button bg-transparent">
        <font-awesome-icon icon="times" />
      </button>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['type', 'visible'],
  data () {
    return {
      alertClass: {
        'alert-info': this.type === 'info',
        'alert-warning': this.type === 'warning',
        'alert-error': this.type === 'error',
        'text-primary': true
      }
    }
  }
}
</script>

<style lang="scss">
.alert-info {
  background-color: #DCEEFB;
}
.alert-warning {
  background-color: #FFF3C4;
}
.alert-error {
  color: white;
  background-color: #FF725C;
}
.alert-grid {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto;
  align-items: center;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
